export default class ToggleShow {
    static init(): void {
        const toggles: NodeListOf<HTMLElement> = document.querySelectorAll('.toggle-show');

        if (toggles.length > 0) {
            toggles.forEach((toggle) => {
                const container: HTMLElement | null = toggle.closest('.toggle-show__area');
                const triggers: NodeListOf<HTMLElement> = toggle.querySelectorAll('.toggle-show__trigger');

                if (container && triggers.length > 0) {
                    const elements = container.querySelectorAll('.toggle-element');
                    if (elements.length > 0) {
                        triggers.forEach((trigger) => {
                            trigger.addEventListener('click', () => {
                                triggers.forEach((trigger) => {
                                    trigger.classList.remove('toggle-show__trigger--active');
                                });

                                elements.forEach((element) => {
                                    element.classList.remove('block');
                                    element.classList.add('none');
                                });

                                const target = trigger.dataset.toggletarget;
                                const targetElements = container.querySelectorAll(
                                    '[data-toggleelement=' + target + ']',
                                );
                                if (targetElements.length > 0) {
                                    targetElements.forEach((element) => {
                                        element.classList.remove('none');
                                        element.classList.add('block');
                                        trigger.classList.add('toggle-show__trigger--active');
                                    });
                                }
                            });
                        });
                    }
                }
            });
        }
    }
}
